// extracted by mini-css-extract-plugin
export var lFooter = "footer-module--l-footer--1YZe9";